import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

import {
	PrismButtonComponent,
	PrismIconButtonComponent,
	PrismIconComponent,
	PrismMenuComponent,
	PrismMenuItemComponent,
	PrismProfileImageComponent,
	PrismToolbarComponent,
	PrismBetaIndicatorComponent
} from '@shure/prism-angular-components';

import { BreadcrumbsModule } from '../breadcrumbs';

import { HeaderToolbarComponent } from './header-toolbar.component';

@NgModule({
	declarations: [HeaderToolbarComponent],
	exports: [HeaderToolbarComponent],
	imports: [
		CommonModule,
		FlexLayoutModule,
		BreadcrumbsModule,
		RouterModule,
		TranslocoModule,
		PrismButtonComponent,
		PrismToolbarComponent,
		PrismIconButtonComponent,
		PrismMenuComponent,
		PrismMenuItemComponent,
		PrismProfileImageComponent,
		PrismIconComponent,
		PrismBetaIndicatorComponent
	]
})
export class HeaderToolbarModule {}
